<template>
    <v-container>
        <div>
            <v-alert dismissible :value="successVisible" type="success" transition="slide-y-transition">{{this.alertMessage}}</v-alert>
            <v-alert dismissible :value="errorVisible" type="error" transition="slide-y-transition">{{this.alertMessage}}</v-alert>
        </div>
        <v-card>
            <v-card-title>
                Add New User
            </v-card-title>
            <v-card-text>
                <v-form ref="userForm" lazy-validation v-model="isFormValid">
                    <v-text-field dense v-model="newUser.userId" :rules="[v=>!!v || 'User Id is required']" required @blur="onUserBlur">
                            <template #label>User Id <span class="red--text"><strong>*</strong></span></template>
                        </v-text-field>
                        <v-text-field dense v-model="newUser.name" :rules="[v=>!!v || 'User Name i required']" required>
                            <template #label>
                                Name <span class="red--text"><strong>*</strong></span>
                            </template>
                        </v-text-field>
                        <v-text-field dense v-model="newUser.email" :rules="[v=>!!v || 'Email is required']" required>
                            <template #label>Email <span class="red--text"><strong>*</strong></span></template>
                        </v-text-field>
                        
                        <div class="text-right">
                            <v-btn dark color="error" class="ma-2"  @click="cancel">Cancel</v-btn>
                            <v-btn dark color="success" class="ma-2 white--text" @click="saveUser">
                                <v-icon>mdi-content-save</v-icon>
                                Save
                            </v-btn>
                        </div>
                        
                </v-form>
                
            </v-card-text>
        </v-card>
    </v-container>
    
</template>
<script>
    import UserAPI from '@/services/userservice';

    export default{
        name: 'NewUser',
        props:{
            userName:String
        },
        data:function(){
            return {
                isFormValid:false,
                successVisible: false,
                errorVisible:false,
                alertMessage: String,
                newUser:{
                    userId: '',
                    name: this.userName,
                    email: ''
                }
            }
        },
        methods:{
            onUserBlur:async function()
            {
                this.newUser.email=`${this.newUser.userId}@emn.com`
            },
            saveUser:async function(){
                this.isFormValid=this.$refs.userForm.validate()
                if(this.isFormValid)
                {
                    console.log('new user', this.newUser);
                    await UserAPI.addNewUser(this.newUser)
                    .then(response=>{
                        this.alertMessage=response.data.message;
                        if(response.data.isSuccessfull){
                              this.successVisible=true;
                        }
                        else{
                            this.errorVisible=true;
                        }
                        this.$emit('saved',response.data.isSuccessfull,response.data.message,this.newUser);
                    })
                    .catch(error=>{
                        console.log(error);
                        this.alertMessage="Unexpected error has occurred."
                        this.errorVisible=true;
                    });
                    this.hideAlert();
                }
            },
            cancel: async function(){
                this.$emit('canceled',false);
            },
            hideAlert: function(){
             window.setInterval(()=>{
                this.successVisible=false;
                this.errorVisible=false;
            },10000);
        },
        }
    }
</script>